/* eslint-disable indent */
import { Card } from 'antd';
import styled, { css } from 'styled-components';
import { devices } from '../const/devices';

export const StyledCard = styled(Card)<{
	$width?: string;
	$margin?: string;
	$padding?: string;
	$mobilePadding?: string;
	$removeBgOnMobile?: boolean;
	$center?: boolean;
}>`
	width: ${({ $width }) => $width || 'initial'};
	box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.07);
	margin: ${({ $margin }) => $margin};
	box-sizing: border-box;

	.ant-card-body {
		padding: ${({ $padding }) => $padding};

		${({ $center }) =>
			$center &&
			css`
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			`}
	}

	@media ${devices.tablet} {
		${({ $removeBgOnMobile }) =>
			$removeBgOnMobile &&
			css`
				background-color: transparent;
				box-shadow: none;
				border: none;
			`}

		.ant-card-body {
			padding: ${({ $mobilePadding }) => $mobilePadding ?? '0.5rem'};
		}
	}
`;
